export const sendMessageToApp = (type, payload) => {
  const message = JSON.stringify({ type, payload });
  console.log(type, payload);

  // Compatibilità con iOS e Android WebView
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(message);
  } else {
    console.warn("WebView bridge non disponibile");
  }
};

export const refreshCalendar = (onRefresh) => {
  if (typeof onRefresh === 'function') {
    onRefresh();
  }

  if (localStorage.getItem('fromApp')) {
    sendMessageToApp('app:calendarRefresh', {});
  }
};
